import {v4 as uuidv4} from 'uuid';
import rupeeIcon from '../../assets/rupee-icon.png';
export const offerSliderData = [
  {
    id: uuidv4(),
    theme: 'green',
    icon: `${rupeeIcon}`,
    offferText: '0.5% Monthly Cashback',
    showNew: true,
  },
  {
    id: uuidv4(),
    theme: 'blue',
    icon: 'sprite ic_deposit_purple',
    offferText: '1% Recharge Incentive',
  },
  {
    id: uuidv4(),
    theme: 'yellow',
    icon: 'sprite ic_cashback_purple',
    offferText: 'Rs 2000 Instant Cashback',
  },
  {
    id: uuidv4(),
    theme: 'green',
    icon: 'sprite ic_support_purple',
    offferText: '24x7 Hero Hotline',
  },
];

export const faqData = [
  {
    id: uuidv4(),
    question: 'What is MyPartner HERO program',
    answerList: [
      'MMTDOUBLEBLACK is a one-of-a-kind loyalty program with which you can book and travel without worrying about cancellation charges',
      'This program empowers you to cancel your 2 domestic flights + 2 domestic hotels, free of cost! You can select the 2 bookings for cancellation from the multiple bookings list and the first two cancellations will be covered under the program. The annual total cancellation (including both Dom Flights & Dom Hotels for Member + 1 Co Traveller) refund amount will be capped at Rs. 20,000, under your MMTDOUBLEBLACK membership.',
      'With this program, you get free cancellations for the member + 1 co-traveller.',
      'This program also offers premium customer care service with an on-trip travel hotline. This service is exclusive for MMTDOUBLEBLACK members.',
      'As an MMTDOUBLEBLACK member, you also get automatically enrolled in MMTBLACK—our invite-only loyalty program, where you can earn up to Rs. 25,000 in My Cash and use it without any restrictions to book flights and hotels, and claim exciting vouchers.',
    ],
  },
  {
    id: uuidv4(),
    question: 'What is MyPartner HERO program',
    answerList: [
      'MMTDOUBLEBLACK is a one-of-a-kind loyalty program with which you can book and travel without worrying about cancellation charges',
      'This program empowers you to cancel your 2 domestic flights + 2 domestic hotels, free of cost! You can select the 2 bookings for cancellation from the multiple bookings list and the first two cancellations will be covered under the program. The annual total cancellation (including both Dom Flights & Dom Hotels for Member + 1 Co Traveller) refund amount will be capped at Rs. 20,000, under your MMTDOUBLEBLACK membership.',
      'With this program, you get free cancellations for the member + 1 co-traveller.',
      'This program also offers premium customer care service with an on-trip travel hotline. This service is exclusive for MMTDOUBLEBLACK members.',
      'As an MMTDOUBLEBLACK member, you also get automatically enrolled in MMTBLACK—our invite-only loyalty program, where you can earn up to Rs. 25,000 in My Cash and use it without any restrictions to book flights and hotels, and claim exciting vouchers.',
    ],
  },
  {
    id: uuidv4(),
    question: 'What is MyPartner HERO program',
    answerList: [
      'MMTDOUBLEBLACK is a one-of-a-kind loyalty program with which you can book and travel without worrying about cancellation charges',
      'This program empowers you to cancel your 2 domestic flights + 2 domestic hotels, free of cost! You can select the 2 bookings for cancellation from the multiple bookings list and the first two cancellations will be covered under the program. The annual total cancellation (including both Dom Flights & Dom Hotels for Member + 1 Co Traveller) refund amount will be capped at Rs. 20,000, under your MMTDOUBLEBLACK membership.',
      'With this program, you get free cancellations for the member + 1 co-traveller.',
      'This program also offers premium customer care service with an on-trip travel hotline. This service is exclusive for MMTDOUBLEBLACK members.',
      'As an MMTDOUBLEBLACK member, you also get automatically enrolled in MMTBLACK—our invite-only loyalty program, where you can earn up to Rs. 25,000 in My Cash and use it without any restrictions to book flights and hotels, and claim exciting vouchers.',
    ],
  },
];

export const getStartedData = [
  {
    id: uuidv4(),
    imgUurl: 'https://picsum.photos/490/410?random=1',
    listData: [
      {
        id: uuidv4(),
        icon: '',
        description:
          'Book more and complete a travelled booking worth <span>3 lacs</span> in the current month and qualify for the Hero program in the coming month.',
      },
      {
        id: uuidv4(),
        icon: '',
        description: 'Once you qualify, you enjoy Hero benefits for the complete month.',
      },
    ],
  },
  {
    id: uuidv4(),
    imgUurl: 'https://picsum.photos/490/410?random=2',
    listData: [
      {
        id: uuidv4(),
        icon: '',
        description:
          'Book more and complete a travelled booking worth 3 lacs in the current month and qualify for the Hero program in the coming month.',
      },
      {
        id: uuidv4(),
        icon: '',
        description: 'Once you qualify, you enjoy Hero benefits for the complete month.',
      },
    ],
  },
];

export const travelCompletedData = [
  {
    id: uuidv4(),
    from: 'Delhi',
    to: 'Mumbai',
    bookingId: 'NF23567683990',
    bookedOn: '4th March',
    travelOn: '10th April',
    price: '₹8,000',
  },
  {
    id: uuidv4(),
    from: 'Delhi',
    to: 'Mumbai',
    bookingId: 'NF23567683990',
    bookedOn: '4th March',
    travelOn: '10th April',
    price: '₹8,000',
  },
  {
    id: uuidv4(),
    from: 'Delhi',
    to: 'Mumbai',
    bookingId: 'NF23567683990',
    bookedOn: '4th March',
    travelOn: '10th April',
    price: '₹8,000',
  },
  {
    id: uuidv4(),
    from: 'Delhi',
    to: 'Mumbai',
    bookingId: 'NF23567683990',
    bookedOn: '4th March',
    travelOn: '10th April',
    price: '₹8,000',
  },
  {
    id: uuidv4(),
    from: 'Delhi',
    to: 'Mumbai',
    bookingId: 'NF23567683990',
    bookedOn: '4th March',
    travelOn: '10th April',
    price: '₹8,000',
  },
];
export const upcomingTravelData = [
  {
    id: uuidv4(),
    from: 'Goa',
    to: 'Mumbai',
    bookingId: 'NF23567683990',
    bookedOn: '4th March',
    travelOn: '10th April',
    price: '₹8,000',
  },
  {
    id: uuidv4(),
    from: 'Delhi',
    to: 'Mumbai',
    bookingId: 'NF23567683990',
    bookedOn: '4th March',
    travelOn: '10th April',
    price: '₹8,000',
  },
  {
    id: uuidv4(),
    from: 'Delhi',
    to: 'Mumbai',
    bookingId: 'NF23567683990',
    bookedOn: '4th March',
    travelOn: '10th April',
    price: '₹8,000',
  },
  {
    id: uuidv4(),
    from: 'Delhi',
    to: 'Mumbai',
    bookingId: 'NF23567683990',
    bookedOn: '4th March',
    travelOn: '10th April',
    price: '₹8,000',
  },
  {
    id: uuidv4(),
    from: 'Delhi',
    to: 'Mumbai',
    bookingId: 'NF23567683990',
    bookedOn: '4th March',
    travelOn: '10th April',
    price: '₹8,000',
  },
];
export const incentivesData = [
  {
    id: uuidv4(),
    from: 'Bangalore',
    to: 'Mumbai',
    bookingId: 'NF23567683990',
    bookedOn: '4th March',
    travelOn: '10th April',
    price: '₹8,000',
  },
  {
    id: uuidv4(),
    from: 'Delhi',
    to: 'Mumbai',
    bookingId: 'NF23567683990',
    bookedOn: '4th March',
    travelOn: '10th April',
    price: '₹8,000',
  },
  {
    id: uuidv4(),
    from: 'Delhi',
    to: 'Mumbai',
    bookingId: 'NF23567683990',
    bookedOn: '4th March',
    travelOn: '10th April',
    price: '₹8,000',
  },
  {
    id: uuidv4(),
    from: 'Delhi',
    to: 'Mumbai',
    bookingId: 'NF23567683990',
    bookedOn: '4th March',
    travelOn: '10th April',
    price: '₹8,000',
  },
  {
    id: uuidv4(),
    from: 'Delhi',
    to: 'Mumbai',
    bookingId: 'NF23567683990',
    bookedOn: '4th March',
    travelOn: '10th April',
    price: '₹8,000',
  },
];

export const tabData = [
  {
    id: uuidv4(),
    label: 'Travel Completed',
    data: travelCompletedData,
  },
  {
    id: uuidv4(),
    label: 'Yet To Travel',
    data: upcomingTravelData,
  },
  {
    id: uuidv4(),
    label: 'Incentives',
    data: incentivesData,
  },
];

export const monthData = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const monthToShow = ['April', 'May', 'June', 'July', 'August', 'September'];

export const progressTableData = [
  {
    id: uuidv4(),
    month: 'April',
    isCurrent: 'Current Month',
    limit: 300000,
    bookingCompleted: 100000,
    upcomingBooking: 54032,
    totalSaving: 260,
    cta: 'View Details',
  },
  {
    id: uuidv4(),
    month: 'May',
    isCurrent: '',
    limit: 300000,
    bookingCompleted: 0,
    upcomingBooking: 0,
    totalSaving: 260,
    cta: 'View Details',
  },
  {
    id: uuidv4(),
    month: 'June',
    isCurrent: '',
    limit: 300000,
    bookingCompleted: 430000,
    upcomingBooking: 54032,
    totalSaving: 260,
    heroIcon: '../../../assets/hero-logo.png',
    cta: 'View Details',
  },
  {
    id: uuidv4(),
    month: 'July',
    isCurrent: '',
    limit: 300000,
    bookingCompleted: 0,
    upcomingBooking: 0,
    totalSaving: 260,
    cta: 'View Details',
  },
  {
    id: uuidv4(),
    month: 'August',
    isCurrent: '',
    limit: 300000,
    bookingCompleted: 0,
    upcomingBooking: 0,
    totalSaving: 260,
    cta: 'View Details',
  },
  {
    id: uuidv4(),
    month: 'September',
    isCurrent: '',
    limit: 300000,
    bookingCompleted: 0,
    upcomingBooking: 0,
    totalSaving: 260,
    cta: 'View Details',
  },
];

export const journeyMonthData = [
  {
    id: uuidv4(),
    month: 'April',
    current: true,
  },
  {
    id: uuidv4(),
    month: 'May',
  },
  {
    id: uuidv4(),
    month: 'June',
  },
  {
    id: uuidv4(),
    month: 'July',
  },
  {
    id: uuidv4(),
    month: 'August',
  },
  {
    id: uuidv4(),
    month: 'September',
  },
];

export const noDataAxisName = [
  {name: 'April'},
  {name: 'May'},
  {name: 'June'},
  {name: 'July'},
  {name: 'August'},
  {name: 'September'},
];
